import type { AiToolsConsentDecision } from '@unify/fhir-model/resources/consent';

export type AiToolsSwitchAction = 'none' | 'revoke' | 'open-opt-in';

export type AiToolsSwitchUiState = {
  checked: boolean;
  pending: boolean;
  disabled: boolean;
  actionForToggle: (nextChecked: boolean) => AiToolsSwitchAction;
};

/** Maps resolver decision → Settings Security switch behavior. */
export function getAiToolsSwitchUiState(
  decision: AiToolsConsentDecision,
  opts?: { loading?: boolean; saving?: boolean },
): AiToolsSwitchUiState {
  const pending = decision === 'none';
  const checked = decision === 'active';
  const busy = Boolean(opts?.loading || opts?.saving);
  return {
    checked,
    pending,
    disabled: busy || pending,
    actionForToggle: (nextChecked: boolean) => {
      if (pending || busy) return 'none';
      if (decision === 'active' && !nextChecked) return 'revoke';
      if (decision === 'revoked' && nextChecked) return 'open-opt-in';
      return 'none';
    },
  };
}
